const updatePerc = (original, multiplier) => {
  const updated = original * multiplier;
  return updated > 1 ? 1 : updated;
};

const updateHue = (original, multiplier) => {
  const updated = original * multiplier;
  return updated > 255 ? 255 : updated;
};

const setColor = (type, color) => {
  const { h, s, l } = color;
  if (type === 'primary') {
    return {
      dark: {
        h,
        s,
        l: 0.39,
      },
      mid: {
        h,
        s: updatePerc(s, 0.928),
        l: updatePerc(l, 1.46),
      },
      light: {
        h: updateHue(h, 0.78),
        s: updatePerc(s, 1),
        l: 0.96,
      },
    };
  }
  if (type === 'secondary') {
    return {
      dark: { h, s, l: 0.28 },
      mid: { h, s: updatePerc(s, 0.743), l: updatePerc(l, 1.2) },
      light: { h: updateHue(h, 1.019), s: 0.83, l: 0.98 },
    };
  }

  // eslint-disable-next-line no-console
  console.error('no type provided');
};

export default setColor;
